<template>
  <v-card :loading="loading" :disabled="loading">
    <v-card-title>
      <div v-if="isFutureInnovationStudent">
        {{ $t("registration.registration_system_4+1") }}
      </div>
      <div v-else>
        {{ $t("registration.registration_system_x") }}
      </div>
    </v-card-title>
    <v-card-text class="px-0">
      <PageInfo
        v-show="!loading && !error"
        v-if="DISPLAY_INFO_STATE.includes(state)"
        :all_page_states="PAGE_STATE"
        :page_state="state"
        :data_student_no_right="data_student_no_right"
      />

      <RegistrationXPanel
        v-if="
          DISPLAY_REGISTRATION_PANEL_STATE.includes(state) &&
          year &&
          semester &&
          student_id
        "
        :all_page_states="PAGE_STATE"
        :page_state="state"
        :change_period="on_add_change_date"
        :withdraw_period="on_withdraw_date"
        :clear_student="clear_student"
        :fetch_student="fetch_student"
        :check_never_regis="check_never_regis"
        :level_id="level_id"
        :sub_level_id="sub_level_id"
        :year="year"
        :semester="semester"
        :student_id="student_id"
        :student_info="studentInfo"
        :regis_type="regis_type"
        :bypass="bypass"
      />
    </v-card-text>
    <v-card-text class="text-center" v-if="error">
      <h2>มีบางอย่างผิดพลาด</h2>
    </v-card-text>
  </v-card>
</template>

<script>
import RegistrationProvider from "@/services/registration.provider.js";
const RegistrationService = new RegistrationProvider();

// สถานะของหน้า
const PAGE_STATE = {
  DISPLAY_INFO_NOT_LOGGED_IN: "DISPLAY_INFO_NOT_LOGGED_IN",
  DISPLAY_INFO_NOT_IN_REGIS_PERIOD: "DISPLAY_INFO_NOT_IN_REGIS_PERIOD",
  DISPLAY_INFO_NOT_STUDY_STATUS: "DISPLAY_INFO_NOT_STUDY_STATUS",
  DISPLAY_INFO_NOT_FIRST_YEAR_FIRST_SEMESTER:
    "DISPLAY_INFO_NOT_FIRST_YEAR_FIRST_SEMESTER",
  DISPLAY_INFO_NO_RIGHT: "DISPLAY_INFO_NO_RIGHT",
  DISPLAY_INFO_NEVER_REGIS_AND_AFTER_REGIS_DATE:
    "DISPLAY_INFO_NEVER_REGIS_AND_AFTER_REGIS_DATE",
  DISPLAY_INFO_DEFAULT: "DISPLAY_INFO_DEFAULT",

  REGIS: "REGIS", // หน้าทำการลงทะเบียน
  SUMMARY_REGIS: "SUMMARY_REGIS", // หน้าสรุปรายการลงทะเบียน
};
// สถานะใน PAGE_STATE ที่ใช้การแสดง PageInfo
const DISPLAY_INFO_STATE = [
  PAGE_STATE.DISPLAY_INFO_NOT_LOGGED_IN,
  PAGE_STATE.DISPLAY_INFO_NOT_IN_REGIS_PERIOD,
  PAGE_STATE.DISPLAY_INFO_NOT_STUDY_STATUS,
  PAGE_STATE.DISPLAY_INFO_NOT_FIRST_YEAR_FIRST_SEMESTER,
  PAGE_STATE.DISPLAY_INFO_NO_RIGHT,
  PAGE_STATE.DISPLAY_INFO_NEVER_REGIS_AND_AFTER_REGIS_DATE,
  PAGE_STATE.DISPLAY_INFO_DEFAULT,
];
// สถานะใน PAGE_STATE ที่ใช้การแสดง RegistrationPanel
const DISPLAY_REGISTRATION_PANEL_STATE = [
  PAGE_STATE.REGIS,
  PAGE_STATE.SUMMARY_REGIS,
];

// import * as dayjs from "dayjs";
import PageInfo from "./PageInfo.vue";
import RegistrationXPanel from "./RegistrationXPanel.vue";

export default {
  name: "registration_x",
  components: {
    PageInfo,
    RegistrationXPanel,
  },
  props: {
    clear_student: {
      type: Function,
      default: null,
    },
    fetch_student: {
      type: Function,
      default: null,
    },
    selected_year: {
      type: [String, Number],
      default: null,
    },
    selected_semester: {
      type: String,
      default: null,
    },
    selected_student_id: {
      type: String,
      default: null,
    },
    selected_student_info: {
      type: Object,
      default: null,
    },
    selected_is_future_innovation_student: {
      type: Boolean,
      default: false,
    },
    bypass: {
      type: Boolean,
      default: null,
    },
  },
  data: () => ({
    PAGE_STATE,
    DISPLAY_INFO_STATE,
    DISPLAY_REGISTRATION_PANEL_STATE,
    loading: false,
    error: false,

    start_regis_date: null,
    end_regis_date: null,

    start_add_change_date: null,
    end_add_change_date: null,

    is_logged_in: false,

    before_regis_date: false, // true ถ้าอยู่ก่อนช่วงลงทะเบียนปกติ
    on_regis_date: false, // true ถ้าอยู่ในช่วงลงทะเบียนปกติ
    after_regis_date: false, // true ถ้าอยู่หลังช่วงลงทะเบียนปกติ

    before_add_change_date: false, // true ถ้าอยู่ก่อนช่วง เพิ่ม-เปลี่ยน
    on_add_change_date: false, // true ถ้าอยู่ในช่วง เพิ่ม-เปลี่ยน
    after_add_change_date: false, // true ถ้าอยู่หลังช่วง เพิ่ม-เปลี่ยน

    before_withdraw_date: false, // true ถ้าอยู่ก่อนช่วง ถอน
    on_withdraw_date: false, // true ถ้าอยู่ในช่วง ถอน
    after_withdraw_date: false, // true ถ้าอยู่หลังช่วง ถอน

    right_student_status: false, // true ถ้าสถานะเรียนเป็น 'เรียน'
    right_never_regis: false, // true ถ้ายังไม่เคยลงทะเบียนมาก่อน
    right_not_in_student_no_right: false, // true ถ้าไม่อยู่ในตาราง student_no_right เช่น ไม่มีเงินค้างชำระ

    data_student_no_right: [],

    year: null,
    semester: null,
    regis_type: null,
  }),
  computed: {
    student_id() {
      if (this.selected_student_id) return this.selected_student_id;
      return this.$store.state.user.surrogated_student_id;
    },
    studentInfo() {
      return this.selected_student_info || this.$store.state.user.surrogated_student_info;
    },
    studentPrivilege() {
      return (
        this.studentInfo &&
        this.studentInfo.payload &&
        this.studentInfo.payload.ticket &&
        this.studentInfo.payload.ticket.privilege
      );
    },
    isFutureInnovationStudent() {
      if (this.selected_student_info) {
        return this.selected_is_future_innovation_student;
      }
      return (
        this.$store.state.user.is_future_innovation_student
      );
    },
    level_id() {
      return this.studentPrivilege == 80 ? 1 : 2;
    },
    sub_level_id() {
      if (this.isFutureInnovationStudent) return 1;
      else return null;
    },
    // สถานะของหน้าเพจ
    state() {
      if (this.bypass) {
        console.log("state condition: bypassing");
        if (this.right_never_regis) return PAGE_STATE.REGIS;
        return PAGE_STATE.SUMMARY_REGIS;
      }

      // --- Check Login ---
      if (!this.is_logged_in) {
        return PAGE_STATE.DISPLAY_INFO_NOT_LOGGED_IN;
      }

      // --- Check วัน ---
      else if (this.before_regis_date) {
        console.log("state condition: 2");
        return PAGE_STATE.DISPLAY_INFO_NOT_IN_REGIS_PERIOD;
      }

      // --- Check สถานะเรียน ---
      else if (!this.right_student_status) {
        console.log("state condition: 3");
        return PAGE_STATE.DISPLAY_INFO_NOT_STUDY_STATUS;
      }

      // --- Check ไม่อยู่ใน Student no right ---
      else if (!this.right_not_in_student_no_right) {
        console.log("state condition: 5");
        return PAGE_STATE.DISPLAY_INFO_NO_RIGHT;
      }

      // --- Check ยังไม่เคยลงทะเบียน อยู่ในช่วงลงทะเบียน ---
      else if (this.right_never_regis && this.on_regis_date) {
        console.log("state condition: 6");
        return PAGE_STATE.REGIS;
      }

      // --- Check ยังไม่เคยลงทะเบียน อยู่ในช่วงเพิ่มเปลี่ยนถอน ---
      else if (this.right_never_regis && this.on_add_change_date) {
        console.log("state condition: 7.5");
        return PAGE_STATE.REGIS;
      }

      // --- Check ยังไม่เคยลงทะเบียน หลังช่วงลงทะเบียน ---
      else if (this.right_never_regis && this.after_regis_date) {
        console.log("state condition: 7");
        return PAGE_STATE.DISPLAY_INFO_NEVER_REGIS_AND_AFTER_REGIS_DATE;
      }

      // --- Check เคยลงทะเบียนแล้ว ผลยังไม่ออก ---
      else if (!this.right_never_regis) {
        console.log("state condition: 8");
        return PAGE_STATE.SUMMARY_REGIS;
      }

      return PAGE_STATE.DISPLAY_INFO_DEFAULT;
    },
  },
  methods: {
    async get_year_semester() {
      if (this.selected_year && this.selected_semester) {
        this.year = String(this.selected_year);
        this.semester = String(this.selected_semester);
      } else {
        const data = await RegistrationService.getYearSemesterNow(
          this.level_id
        ).catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
          this.error = true;
        });
        this.year = data.YEAR;
        this.semester = data.SEMESTER;
      }
    },

    async check_if_logged_in() {
      this.is_logged_in = true;
    },

    async check_date() {
      const data = await RegistrationService.checkRegistrationDateTime({
        level_id: this.level_id,
        year: this.year,
        semester: this.semester,
        sub_level_id: this.sub_level_id,
      }).catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        this.loading = false;
        this.error = true;
      });
      this.before_regis_date = data.regis.before_date;
      this.on_regis_date = data.regis.on_date;
      this.after_regis_date = data.regis.after_date;

      this.start_regis_date = data.regis.start_date;
      this.end_regis_date = data.regis.end_date;

      // -----------------------------------------------------

      this.start_add_change_date = data.add_change.start_date;
      this.end_add_change_date = data.add_change.end_date;

      this.before_add_change_date = data.add_change.before_date;
      this.on_add_change_date = data.add_change.on_date;
      this.after_add_change_date = data.add_change.after_date;

      this.before_withdraw_date = data.withdraw.before_date;
      this.on_withdraw_date = data.withdraw.on_date;
      this.after_withdraw_date = data.withdraw.after_date;
    },

    async check_student_status() {
      const data = await RegistrationService.isStudentStudyStatus(
        this.student_id,
        this.level_id
      ).catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        this.loading = false;
        this.error = true;
      });
      this.right_student_status = data.status;
    },

    async check_never_regis() {
      const data = await RegistrationService.isNeverRegis({
        student_id: this.student_id,
        year: this.year,
        semester: this.semester,
        level_id: this.level_id,
        sub_level_id: this.sub_level_id,
      }).catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        this.loading = false;
        this.error = true;
      });
      this.right_never_regis = data.status;
      this.regis_type = data.regis_type;
    },

    async check_not_in_student_no_right() {
      const data = await RegistrationService.checkNotInStudentNoRight({
        student_id: this.student_id,
        year: this.year,
        semester: this.semester,
        level_id: this.level_id,
      }).catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        this.loading = false;
        this.error = true;
      });
      this.right_not_in_student_no_right = data.status;
      if (this.right_not_in_student_no_right == false) {
        this.data_student_no_right = data.data;
      }
    },

    async check_condition() {
      this.loading = true;
      await this.check_if_logged_in();
      await this.get_year_semester();
      await this.check_never_regis();
      if (!this.bypass) {
        await this.check_date();
        await this.check_student_status();
        await this.check_not_in_student_no_right();
      }
      this.loading = false;
    },
  },
  created() {
    this.check_condition();
  },
};
</script>
